import {Link, Route, Routes} from "react-router-dom";
import {Home} from './pages/Home'
import {Brunnenwasser} from './pages/Brunnenwasser'
import {Less9Meter} from './pages/Less9Meter'
import styles from './App.module.scss';
import {More9Meter} from "./pages/More9Meter";
import ReactGA from 'react-ga';
import {Regenwasser} from "./pages/Regenwasser";
import {Schmutzwasser} from "./pages/Schmutzwasser";
import {Abwasser} from "./pages/Abwasser";
import {Berater} from "./pages/Berater";
import {AbwasserHausHaeufig} from "./pages/AbwasserHausHaeufig";
import {AbwasserHaus} from "./pages/AbwasserHaus";

const trackingId = "UA-73663831-2";

ReactGA.initialize(trackingId);


function App() {
  return (
    <div className={styles.App}>
      <div className={styles.AppMain}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="brunnenwasser" element={<Brunnenwasser />} />
          <Route path="brunnenwasser/weniger-9-meter" element={<Less9Meter />} />
          <Route path="brunnenwasser/mehr-als-9-meter" element={<More9Meter />} />
          <Route path="regenwasser" element={<Regenwasser />} />
          <Route path="schmutzwasser" element={<Schmutzwasser />} />
          <Route path="abwasser" element={<Abwasser />} />
          <Route path="abwasser/im-haus" element={<AbwasserHaus />} />
          <Route path="abwasser/im-haus/haeufig" element={<AbwasserHausHaeufig />} />
          <Route path="berater" element={<Berater />} />
        </Routes>
      </div>
    </div>
  );
}



function About() {
  return (
    <>
      <main>
        <h2>Who are we?</h2>
        <p>
          That feels like an existential question, don't you
          think?
        </p>
      </main>
      <nav>
        <Link to="/">Home</Link>
      </nav>
    </>
  );
}

export default App;
